import { render, staticRenderFns } from "./SearchCategoryForm.vue?vue&type=template&id=980992cc&"
import script from "./SearchCategoryForm.vue?vue&type=script&lang=ts&"
export * from "./SearchCategoryForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports